import { TranslateFunction } from 'react-localize-redux';

import {
  CollectionRestaurantDetail,
  DeliveryRestaurantDetail,
  DeliveryType,
} from '../../../core/api/restaurant/restaurant.types';

type CheckoutButtonStateType = {
  buttonLabel: string;
  isCheckoutEnabled: boolean;
};

export const checkIsOutsideDeliveryZone = (
  restaurant: DeliveryRestaurantDetail | CollectionRestaurantDetail,
): boolean =>
  restaurant?.DeliveryType === DeliveryType.Delivery &&
  restaurant?.UserOutsideDeliveryZone;

export const getAriaLabel = (
  name: string,
  description: string,
  from: boolean,
  currencySymbol: string,
  translate: any,
): string =>
  `${name}, ${description} ${from && translate('From')} ${currencySymbol}`;

export const getButtonState = (
  acceptPreOrders: boolean,
  isDeliveryOrder: boolean,
  isOutsideDeliveryZone: boolean,
  isOpen: boolean,
  translate: any,
): CheckoutButtonStateType => {
  if (isDeliveryOrder && isOutsideDeliveryZone) {
    return {
      buttonLabel: translate('Cannot_deliver_checkout'),
      isCheckoutEnabled: false,
    };
  }

  if (isOpen) {
    return {
      buttonLabel: translate('Checkout'),
      isCheckoutEnabled: true,
    };
  }

  if (acceptPreOrders) {
    return {
      buttonLabel: translate('Preorder'),
      isCheckoutEnabled: true,
    };
  }

  return {
    buttonLabel: translate('Closed'),
    isCheckoutEnabled: false,
  };
};

// TODO - ORD-1200 remove this function when useBasket is rolled out to Menu page
export const checkIsClosedAndDisplayAlert = (
  restaurantDetailData: CollectionRestaurantDetail | DeliveryRestaurantDetail,
  translate: TranslateFunction,
): boolean => {
  const getOpeningTime = (): string => {
    const openTimeMinuteString =
      `00${restaurantDetailData.OpenTimeMinute}`.slice(-2);
    const openTimeHourString = `00${restaurantDetailData.OpenTimeHour}`.slice(
      -2,
    );
    return `${openTimeHourString}:${openTimeMinuteString}`;
  };

  if (!restaurantDetailData.IsOpen && !restaurantDetailData.AcceptPreOrders) {
    const openAt = getOpeningTime();
    // eslint-disable-next-line no-alert
    alert(
      translate('Sorry_{restaurantName}_is_closed_It_will_open_at_{openAt}', {
        restaurantName: restaurantDetailData.RestaurantName,
        openAt,
      }),
    );

    return true;
  }

  return false;
};
